export const FILTER_TYPES = {
  all: 'all',
  unread: 'unread',
  sent: 'sent',
  scheduled: 'scheduled',
  drafts: 'drafts',
  flagRed: 'flag_red',
  flagOrange: 'flag_orange',
  flagYellow: 'flag_yellow',
  flagGreen: 'flag_green',
  flagBlue: 'flag_blue',
  archived: 'archived',
};

export const FLAG_COLORS = {
  red: '#F44336',
  orange: '#FF9800',
  yellow: '#FFEB3B',
  green: '#4CAF50',
  blue: '#2196F3',
};
